// https://ralexanderson.com/blog/spreading-events-in-react-with-pubsub

import { v4 } from 'uuid';

const topics = {};

export function subscribe(topic, fn) {
    if (!topics[topic]) topics[topic] = {};
    const id = v4();
    topics[topic][id] = fn;
    return () => {
        topics[topic][id] = null;
        delete topics[topic][id];

        return null;
    };
}

export function publish(topic, args) {
    if (!topics[topic]) return;
    Object.values(topics[topic]).forEach((fn) => {
        try {
            if (fn) fn(args);
        } catch (error) {}
    });
}
